import { createSlice } from "@reduxjs/toolkit";

const authReducer = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    user: null,
    token: null,
    subscription: null,
    globalSearch: {
      search: "",
      category: null,
      recallDate: null,
      manufacturer: null,
    }
  },
  reducers: {
    loggedIn: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    setOtpEmail: (state, action) => {
      state.otpEmail = action.payload;
    },
    logout: (state) => {
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token: null,
        otpEmail: null,
        subscription: null,
        globalSearch: {
          search: "",
          category: null,
          recallDate: null,
          manufacturer: null,
        }
      };
    },
    globalSearch: (state, action) => {
      return {
        ...state,
        globalSearch: {
          ...state.globalSearch,
          ...action.payload
        }
      };
    }
  }
});

export const { loggedIn, logout, globalSearch, setOtpEmail } = authReducer.actions;
export default authReducer.reducer;
